import { sha256 } from "@noble/hashes/sha256";
import { FILE_CHUNK_SIZE } from "./constants";

const UNSUPPORTED_FILE_EXTENSIONS = /^.*\.(e01|mdf|nrg|ovf|run)$/i;
const LIMITED_SUPPORT_EXTENSIONS = /^.*\.(ova|vdi|vhd|vhdx|vmdk)$/i;

export const isFileExtensionSupported = (fileName: string): boolean => {
  return !fileName.match(UNSUPPORTED_FILE_EXTENSIONS);
};

export const fileExtensionHasLimitedSupport = (fileName: string): boolean => {
  return fileName.match(LIMITED_SUPPORT_EXTENSIONS) !== null;
};

export const initializeSha256Hash = () => sha256.create();

export const getFileChunksCount = (file: File): number => {
  const fileSize = file.size;
  const totalChunks = Math.ceil(fileSize / FILE_CHUNK_SIZE);

  return totalChunks;
};
